import React from 'react';
import { accountRegions } from '../../../helper/DataArrays';

// A judge's region (card 930d3ac0, Devin 2026-10-27). A judge in the CLRG
// directory has it from there (read-only here); for anyone else an admin picks
// it, and the judge's account takes it when they accept the invitation - the
// invitation page never asks. The server writes the place shown from it, so
// an adjudicator has no Location box.
export const listedInDirectory = (collab) => !!collab?.clrg?.id;
export const regionOf = (collab) => collab?.clrg?.region || "";

const JudgeRegionField = ({ formik, collab }) => {
    if (listedInDirectory(collab)) {
        return (
            <div className="d-grid mb-3">
                <label className="label-head-org">Region:</label>
                <span style={{ fontSize: "13px", color: "#797979" }}>{collab?.location || regionOf(collab)} (from the CLRG directory)</span>
            </div>
        );
    }
    const error = formik.touched.region && formik.errors.region;
    return (
        <div className="d-grid mb-3">
            <label className={error ? "label-head-org-error" : "label-head-org"}>Region:</label>
            <select
                name="region"
                value={formik.values.region}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="tabulate-select"
                style={{ border: "1px solid #797979" }}
            >
                <option value="" disabled>Select a region</option>
                {accountRegions.map((r) => <option key={r.value} value={r.value}>{r.key}</option>)}
            </select>
            {error && <span className="error mt-2">{formik.errors.region}</span>}
        </div>
    );
};

export default JudgeRegionField;
